import { AstNodeCategory, AstNodeType } from './node';
export class FunctionLiteral {
    constructor(token, parameters = [], body) {
        this.token = token;
        this.parameters = parameters;
        this.body = body;
        this.nodeType = AstNodeType.FunctionLiteral;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Parameters() {
        return this.parameters;
    }
    set Parameters(val) {
        if (Array.isArray(val)) {
            this.parameters = val;
        }
        else {
            this.parameters = [];
        }
    }
    get Body() {
        return this.body;
    }
    set Body(val) {
        this.body = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return `${this.tokenLiteral()}(${this.parameters
            .map((p) => p.toString())
            .join(', ')})
        ${this.body.toString()}`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnVuY3Rpb25MaXRlcmFsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hc3QvRnVuY3Rpb25MaXRlcmFsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlBLE9BQU8sRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUFjLE1BQU0sUUFBUSxDQUFDO0FBRWxFLE1BQU0sT0FBTyxlQUFlO0lBQ3hCLFlBQ1ksS0FBWSxFQUNaLGFBQTJCLEVBQUUsRUFDN0IsSUFBcUI7UUFGckIsVUFBSyxHQUFMLEtBQUssQ0FBTztRQUNaLGVBQVUsR0FBVixVQUFVLENBQW1CO1FBQzdCLFNBQUksR0FBSixJQUFJLENBQWlCO1FBR2pDLGFBQVEsR0FBZ0IsV0FBVyxDQUFDLGVBQWUsQ0FBQztRQUNwRCxpQkFBWSxHQUFvQixlQUFlLENBQUMsVUFBVSxDQUFDO0lBSHhELENBQUM7SUFLSixJQUFJLFVBQVU7UUFDVixPQUFPLElBQUksQ0FBQyxVQUFVLENBQUM7SUFDM0IsQ0FBQztJQUVELElBQUksVUFBVSxDQUFDLEdBQUc7UUFDZCxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUU7WUFDcEIsSUFBSSxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUM7U0FDekI7YUFBTTtZQUNILElBQUksQ0FBQyxVQUFVLEdBQUcsRUFBRSxDQUFDO1NBQ3hCO0lBQ0wsQ0FBQztJQUVELElBQUksSUFBSTtRQUNKLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQztJQUNyQixDQUFDO0lBRUQsSUFBSSxJQUFJLENBQUMsR0FBRztRQUNSLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0lBQ3BCLENBQUM7SUFFRCxZQUFZO1FBQ1IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztJQUM5QixDQUFDO0lBRUQsUUFBUTtRQUNKLE9BQU8sR0FBRyxJQUFJLENBQUMsWUFBWSxFQUFFLElBQUksSUFBSSxDQUFDLFVBQVU7YUFDM0MsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUM7YUFDeEIsSUFBSSxDQUFDLElBQUksQ0FBQztVQUNaLElBQUksQ0FBQyxJQUF1QixDQUFDLFFBQVEsRUFBRSxFQUFFLENBQUM7SUFDakQsQ0FBQztDQUNKIn0=